import type { FaireProductEntity } from "../../entity_types/product";

export const p_psfyh5rbww: FaireProductEntity = {
  token: "p_psfyh5rbww",
  type: "product",
  name: "Famille Perronneau Flower-shaped Honey Sweets 4.59oz",
  brandToken: "b_9anqzdvs32",
  brandName: "The French Farm",
  imageUrl:
    "https://cdn.faire.com/fastly/579b66b45d590f4d3787457c9d9fb492c6ef8daf1dc7214938cf3a11d03eff8c.jpeg",
  galleryImageUrls: [],
  priceDollars: 5.64,
  description:
    "Enjoy these assorted flavors of honey candies any time of day! Made with natural flavors and colors, and no preservatives, these candies are sure to delight both the young and the old, and everyone in between! Ingredients: Sugar, glucose syrup, honey 12%, acidifying: citric acid, liquorice powder, natural flavors of lemon, orange and mint, fruit and vegetable juice for color, natural colorings: curcumin, plain caramel, paprika extract. May contain traces of peanuts, almonds, hazelnuts, and milk.",
  tags: [],
  msrpDollars: 11.28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:07.185Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
